import {useCallback, useEffect, useMemo, useRef, useState} from 'react';

import {useUDData} from '@udemy/ud-data';

import {UserEnrollmentStore} from '../stores/user-enrollment.mobx-store';
import {EnrolledCourses} from '../types/enrolledCourses';

export function useEnrolledCourses(userId: string, topicId: string) {
    const [enrolledCourses, setEnrolledCourses] = useState<EnrolledCourses[]>([]);
    const udData = useUDData();
    const userEnrollmentStore = useMemo(() => new UserEnrollmentStore(), []);
    const isMounted = useRef(true);
    const [isLoaded, setIsLoaded] = useState(false);

    const userHasOrganization = udData.Config.brand.has_organization;
    const organizationId = userHasOrganization
        ? udData.Config.brand.organization.id.toString()
        : '';

    const loadUserCourseEnrollments = useCallback(async () => {
        if (userId.length === 0 || organizationId.length === 0 || topicId.length === 0) {
            setIsLoaded(true);
            return [];
        }

        await userEnrollmentStore.fetchResources(organizationId, userId, topicId);
        setIsLoaded(true);

        if (isMounted.current) {
            setEnrolledCourses(userEnrollmentStore.getCourses());
        }
    }, [userId, organizationId, topicId, userEnrollmentStore]);

    useEffect(() => {
        isMounted.current = true;

        loadUserCourseEnrollments();

        return () => {
            isMounted.current = false; // setting isMounted to false on unmount
        };
    }, [loadUserCourseEnrollments]);

    return {enrolledCourses, isLoaded};
}
